import React from 'react';
import { useCurrentEditor } from '@tiptap/react';

import FontComponent from './FontComponent';

const HEADING_OPTIONS = [
  { label: 'Normal', value: 'paragraph' },
  { label: 'Heading 1', value: '1' },
  { label: 'Heading 2', value: '2' },
  { label: 'Heading 3', value: '3' },
];

const HeadingSelector: React.FC = () => {
  const { editor } = useCurrentEditor();

  const handleChange = (value: string) => {
    if (value === 'paragraph') {
      editor?.chain().focus().setParagraph().run();
    } else {
      const level = parseInt(value, 10) as 1 | 2 | 3;
      editor?.chain().focus().toggleHeading({ level }).run();
    }
  };

  const isActiveFunc = (value: string): boolean => {
    if (value === 'paragraph') {
      return !!editor?.isActive('paragraph') && !editor?.isActive('heading');
    }
    const level = parseInt(value, 10);
    return !!editor?.isActive('heading', { level });
  };

  return (
    <FontComponent
      options={HEADING_OPTIONS}
      label="Text style"
      defaultOption="Normal"
      containerClassName="w-80"
      isActiveFunc={isActiveFunc}
      isEnabledFunc={() => true}
      handleChange={handleChange}
    />
  );
};

export default HeadingSelector;
